import React from "react";
import { withFormik, Form } from "formik";
import { func, bool, shape } from "prop-types";
import { Col } from "react-bootstrap";
import classNames from "classnames";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { compose } from "redux";

import { selectors as fundcorpSelectors, actions as fundcorpActions } from "reducers/fundcorp";
import * as i18nUtils from "util/i18n";
import I18n from "pages/_components/I18n";
import Notification from "pages/_components/Notification";
import Head from "pages/_components/Head";
import Container from "pages/_components/Container";
import Button from "pages/_components/Button";
import { useEmbeddedV3ShellLayoutSync } from "util/v3ShellLayoutSync";
import CancelSummaryData from "./CancelSummaryData";

function FundCancelSummary({ isDesktop, dispatch, isSubmitting, summary, embeddedInV3Shell }) {
    useEmbeddedV3ShellLayoutSync(dispatch, {
        embeddedInV3Shell,
        isDesktop,
        titleKey: "fund.cancel.summary.label",
        goBackPath: "/fundcorpOperations",
        scopes: ["cancelFound"],
    });

    const handleBack = () => {
        dispatch(push("/fundcorpOperations"));
    };

    const confirmButton = (
        <Col className="confirmation__content-button" lg={12} md={12} sm={12}>
            <div className="admin-content-center">
                <Button
                    image="images/arrowRight.svg"
                    imageStyle={isDesktop ? "mr-2" : "mr-1"}
                    type="submit"
                    bsStyle="primary"
                    label="global.confirm"
                    loading={isSubmitting}
                />
            </div>
        </Col>
    );

    if (!summary?.cuotapartistaNumero) {
        handleBack();
    }
    return (
        <>
            {!embeddedInV3Shell && <Notification scopeToShow="cancelFound" />}
            {!(embeddedInV3Shell && !isDesktop) && (
                <div className="admin-detail-head px-0">
                    <Head
                        onBack={handleBack}
                        title={!isDesktop ? "fund.cancel.summary.label" : undefined}
                        titleClassName="text-white"
                        accessibilityTextId="fund.cancel.summary.label"
                        headerClassName={classNames({
                            "blue-main-header-mobile": !isDesktop,
                        })}
                        centerContentClassName={classNames({
                            "mx-5": !isDesktop,
                        })}
                    />
                    {isDesktop && <h1 className="mt-1 mb-3">{i18nUtils.get("fund.cancel.summary.label")}</h1>}
                </div>
            )}
            <Form className="confirmation__container">
                <Container
                    className={classNames("", {
                        "flex-grow align-items-center cmf-container-white pt-3": !isDesktop,
                    })}
                    gridClassName={!isDesktop ? "form-content" : "confirmation__form confirmation__box py-5"}>
                    <div
                        className={classNames("admin-content-center", {
                            "mb-3 px-4": !isDesktop,
                        })}>
                        <I18n
                            id="fund.cancel.summary.checkInfo.label"
                            component={!isDesktop ? "h2" : "h1"}
                            componentProps={{ className: classNames({ "f-size-35": !isDesktop }) }}
                        />
                    </div>
                    <Col className={`col-12 ${!isDesktop && "pt-3 mt-3"}`} lg={12} md={9} sm={12}>
                        <CancelSummaryData isDesktop={isDesktop} spaceBetween />
                        <div className="admin-content-center">
                            <I18n
                                id="confirmation.withoutotp.text"
                                component="p"
                                componentProps={{ className: "confirmation__text-without-otp" }}
                            />
                        </div>
                    </Col>
                    {isDesktop && (
                        <Container className="flex-grow align-items-center w-100" gridClassName="form-content">
                            {confirmButton}
                        </Container>
                    )}
                </Container>
                {!isDesktop && (
                    <Container
                        className="container--layaut flex-grow align-items-center cmf-container-white without-margin-top w-100"
                        gridClassName={
                            !isDesktop ? "form-content" : "confirmation__form confirmation__box-transparent"
                        }>
                        <Col className="col-12 col-xl-4" lg={4} md={9} sm={12}>
                            {confirmButton}
                        </Col>
                    </Container>
                )}
            </Form>
        </>
    );
}

FundCancelSummary.propTypes = {
    dispatch: func.isRequired,
    isDesktop: bool,
    isSubmitting: bool,
    summary: shape({}).isRequired,
    embeddedInV3Shell: bool,
};

FundCancelSummary.defaultProps = {
    embeddedInV3Shell: false,
    isDesktop: true,
    isSubmitting: false,
};

const mapStateToProps = (state) => ({
    summary: fundcorpSelectors.getSummary(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        handleSubmit: (_, formikBag) => {
            const { dispatch, summary } = formikBag.props;

            dispatch(fundcorpActions.cancelSubscribe(summary, formikBag));
        },
    }),
)(FundCancelSummary);
